import { CheckoutResponse } from '~client/model/checkout-response';
import { SecondaryExchangeOfferGroupRequest } from '~client/model/secondary-exchange-offer-group-request';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';

export const reviewResaleListing: OneArgTask<
  SecondaryExchangeOfferGroupRequest,
  CheckoutResponse
> = rxTask<SecondaryExchangeOfferGroupRequest, CheckoutResponse>(
  (request: SecondaryExchangeOfferGroupRequest) =>
    apiClient.resaleController.reviewResaleListing$(request),
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/interactor/resale/review-selling-listing.ts